var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeditation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.5V15.5M12.9996 15.5L12.9999 9.5M16 21.5C12 20.2271 4 17.3757 4 16.1536C4 14.8812 8.62573 15.7286 10.9415 16.4886C11.6158 16.7099 12.3842 16.7099 13.0585 16.4886C15.3743 15.7286 20 14.8812 20 16.1536C20 17.3757 12 20.2271 8 21.5M3 12.5C7.8 12.5 9 9.53957 10.2 8.94554C11.4 8.35151 12.6 8.35141 13.8 8.94569C15 9.53998 16.2 12.5 21 12.5M13.25 4.25C13.25 4.94036 12.6904 5.5 12 5.5C11.3096 5.5 10.75 4.94036 10.75 4.25C10.75 3.55964 11.3096 3 12 3C12.6904 3 13.25 3.55964 13.25 4.25Z",
    stroke: "#F2F2F2",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeditation);
export default __webpack_public_path__ + "static/media/meditation.98452e21e62fef9e2af082f50c688220.svg";
export { ForwardRef as ReactComponent };